export default __webpack_public_path__ + "static/38-05bc02384e0a397e0f871907600a9282.png";